const RealizeInputFile = window.InputFile;

import { forwardPropsToState } from '../../../utils/react_utils';

import InputText from 'realize/components/input/input_text';

@forwardPropsToState([{prop: 'fileData'}, {prop: 'value'}])
export default class InputFile extends RealizeInputFile {

	state = {
		fileData: this.props.fileData
	};

	constructor(props, ctx) {
		super(props, ctx);
		this.handleChange = InputFile.prototype.handleChange.bind(this);
	}

	componentDidMount() {}

	render() {
		return (
			<div className={this.wrapperClassName()}>
			{this.renderFileButton()}
			{this.renderFilePath()}
			</div>
		);
	}

	handleKeyDown(e){
		if(e.keyCode === 13){
			$(".inputImportDocument")[0].click();
		}

		if(e.shiftKey && e.keyCode === 9)
			return false
	}

	renderFileButton() {
		const fileName = (this.props.fileData && this.props.fileData.name) ? this.props.fileData.name : '';

		return (
			<div className={this.buttonClassName() + ' btn-import-document'} onKeyDown={this.handleKeyDown.bind(this)}>
				<span aria-label={fileName} aria-describedby={'file-name'}>{this.getButtonName()}</span>
				<span className={"hidden"} id="file-name">{fileName}</span>
				<input {...this.props}
					value={this.state.value}
					onChange={this.handleChange}
					disabled={this.props.disabled || this.props.readOnly}
					type="file"
					ref="input"
				/>
			</div>
		);
	}

	renderFilePath() {
		return (
			<div className={this.filePathWrapperClassName()}>
				<InputText
					className={this.inputClassName()}
					placeholder={this.getLabelName()}
					onFocus={this._handleFocus}
					ref="filePath"
					readOnly={this.props.inputReadOnly}
					value={this.getFileName()}/>
			</div>
		);
	}

	handleChange(event) {
		this._handleChange(event);
		const [ fileData ] = event.target.files;
		this.setState({ fileData });
	}

	getFileName() {
		return this.state.fileData ? this.state.fileData.name : "";
	}
}
